// deps
import React, { memo } from "react";

// styles
import { Container } from "./styles/OverlayTurbo.style";

interface IOverlayTurboProps {
    onClick: VoidFunction;
}

const OverlayTurbo = ({ onClick }: IOverlayTurboProps) => {
    return <Container onClick={onClick} />;
};

export default memo(OverlayTurbo);
